import urlSlug from "url-slug";

export const slugifyItemName = (name: string): string => urlSlug(name) || "untitled";
